import { FormType } from "@bankingright-dashboard/enums";
import { AccountAccessForm } from "./form";

export const AccountAccessCreate = () => {
    return (
        <AccountAccessForm type={FormType.create} />
    );
};